export function calculateAge(dateOfBirth: string | Date | null | undefined): number | null {
  if (!dateOfBirth) {
    return null;
  } // Return null if no date is provided

  let birthDate: Date;

  if (typeof dateOfBirth === 'object' && dateOfBirth instanceof Date) {
    // It's a Date object
    birthDate = dateOfBirth;
  } else if (typeof dateOfBirth === 'string') {
    // It's a string, parse it
    const parsedDate = new Date(dateOfBirth);
    if (isNaN(parsedDate.getTime())) {
      return null; // invalid date string
    }
    birthDate = parsedDate;
  } else {
    // fallback: null or unexpected type
    return null;
  }

  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();

  // Adjust age if the current date is before the birthday this year
  if (
    today.getMonth() < birthDate.getMonth() ||
    (today.getMonth() === birthDate.getMonth() && today.getDate() < birthDate.getDate())
  ) {
    age--;
  }

  return age;
}

